import { Button, Toggle } from "@EMOrg-prd/react-standard";
import { clients } from "../modules/Clients";
import { scopes } from "../modules/Scopes";
import CodeBox from "./CodeBox";
import TypeaheadField from "./TypeaheadField";
import { useMsal } from "@azure/msal-react";
import { useState, useCallback, useMemo } from "react";
import { requestToken } from "../modules/AuthUtilities";
import { useForm } from "../modules/FormContext";
import { Item } from "../models/General";
import WebhookCredentialForm from "./WebhookCredentialForm";

const filterSortItems = (items: Item[], layer: string) =>
  items
    .filter((item) => item.layer === layer)
    .sort((a, b) => a.name.localeCompare(b.name));

const TokenForm = () => {
  const { instance, accounts } = useMsal();
  const { clientId, scope, layer, setClientId, setScope, setLayer } = useForm();

  const [token, setToken] = useState("");

  const handleTokenRequest = useCallback(async () => {
    await requestToken({ clientId, scope, layer }, setToken, {
      instance,
      account: accounts[0],
    });
  }, [instance, accounts, clientId, scope, layer]);

  const filteredClients = useMemo(() => filterSortItems(clients, layer), [layer]);
  const filteredScopes = useMemo(() => filterSortItems(scopes, layer), [layer]);
  const buttonDisabled = useMemo(() => !(scope && clientId), [scope, clientId]);
  const jwtButtonDisabled = useMemo(() => !token, [token]);
  const jwtLink = useMemo(() => `https://jwt.ms/#id_token=${token}`, [token]);

  return (
    <>
      <form
        onSubmit={async (e) => {
          e.preventDefault();
          await handleTokenRequest();
        }}
      >
      <Toggle label="Identity Provider">
        <Toggle.Item
          id="toggle-1"
          key="toggle-1"
          value="experience"
          onChange={(e) => setLayer(e.target.value)}
          checked={layer === "experience"}
        >
          Experience Layer
        </Toggle.Item>
        <Toggle.Item
          id="toggle-3"
          key="toggle-3"
          value="process"
          onChange={(e) => setLayer(e.target.value)}
          checked={layer === "process"}
        >
          Process Layer
        </Toggle.Item>
      <Toggle.Item
          id="toggle-5"
          key="toggle-5"
          value="outbound"
          onChange={(e) => setLayer(e.target.value)}
          checked={layer === "outbound"}
        >
          Outbound Layer
        </Toggle.Item>
      </Toggle>

      <TypeaheadField
        label="I want to access this API — Scope"
        placeholder="Enter API Scope"
        items={filteredScopes}
        value={scope}
        onChange={setScope}
        clearable
      />

      <TypeaheadField
        label="On behalf of this principal — Client"
        placeholder="Enter Client ID"
        items={filteredClients}
        value={clientId}
        onChange={setClientId}
        clearable
      />

      <Button
        type="submit"
        variant="primary"
        style={{ width: "100%" }}
        disabled={buttonDisabled}
      >
        Request Token
      </Button>

      <CodeBox
        value={token}
        placeholder={
          'Enter client id and scope then click on "Request token" your token will appear here'
        }
      />

      <a href={jwtLink} target="_blank" rel="noreferrer">
        <Button
          variant="secondary"
          style={{ width: "100%" }}
          size="small"
          disabled={jwtButtonDisabled}
        >
          View on jwt.ms
        </Button>
      </a>
      </form>
      <WebhookCredentialForm />
    </>
  );
};

export default TokenForm;
